<template>
  <v-container class="edit-access-key-page" fluid>
    <v-breadcrumbs :items="items" class="px-0 pt-0 pb-2" />
    <div class="edit-access-key-page__header">
      <h1 class="edit-access-key-page__title">{{ $route.meta.title }}</h1>
      <v-btn
        text
        class="text-none"
        color="primary"
        :to="listLocation"
      >
        <v-icon left small>mdi-arrow-left</v-icon>
        К списку ключей
      </v-btn>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card class="edit-access-key-page__card" flat outlined>
        <div class="edit-access-key-page__section edit-access-key-page__section--data">
          <div class="edit-access-key-page__section-title">
            <v-icon left small>mdi-key-variant</v-icon>
            Данные ключа
          </div>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                ref="codeKey"
                v-model="codeKey"
                prepend-inner-icon="mdi-key-outline"
                label="Код ключа"
                outlined
                dense
                :rules="[
                  () => !!codeKey || 'Обязательное поле',
                  () => /^[0-9A-F]{5,}$/.test(codeKey) || 'Минимум 5 символов: только цифры и заглавные буквы A–F',
                  () => !/^0+$/.test(codeKey) || 'Код не может состоять только из нулей',
                  () => !/^000/.test(codeKey) || 'Код не может начинаться с трех нулей',
                ]"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                ref="nameKey"
                v-model="nameKey"
                prepend-inner-icon="mdi-rename-box-outline"
                label="Название ключа"
                outlined
                dense
                :maxlength="64"
                counter="64"
                :rules="[v => !!(v != null ? String(v) : '').trim() || 'Обязательное поле']"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="selectedType"
                :items="typeKey"
                item-value="id"
                item-text="value"
                prepend-inner-icon="mdi-alert-circle-outline"
                label="Тип ключа"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-textarea
                v-model="comment"
                label="Комментарий"
                outlined
                dense
                rows="2"
                clearable
                prepend-inner-icon="mdi-comment-outline"
                auto-grow
                hide-details
              />
            </v-col>
          </v-row>
        </div>

        <v-divider class="my-0" />

        <div class="edit-access-key-page__section">
          <div class="edit-access-key-page__section-title">
            <v-icon left small>mdi-nfc</v-icon>
            Считыватели
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <div class="edit-access-key-page__reader-block">
                <div class="edit-access-key-page__reader-title">Внутренний считыватель</div>
                <div class="edit-access-key-page__reader-checkboxes">
                  <v-checkbox v-model="internal_reader" value="1" label="Замок A" hide-details color="primary" />
                  <v-checkbox v-model="internal_reader" value="2" label="Замок B" hide-details color="primary" />
                  <v-checkbox v-model="internal_reader" value="3" label="Замок C" hide-details color="primary" />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="edit-access-key-page__reader-block">
                <div class="edit-access-key-page__reader-title">Внешний считыватель</div>
                <div class="edit-access-key-page__reader-checkboxes">
                  <v-checkbox v-model="external_reader" value="1" label="Замок A" hide-details color="primary" />
                  <v-checkbox v-model="external_reader" value="2" label="Замок B" hide-details color="primary" />
                  <v-checkbox v-model="external_reader" value="3" label="Замок C" hide-details color="primary" />
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <v-divider class="my-0" />

        <div class="edit-access-key-page__actions">
          <v-btn
            color="primary"
            class="text-none"
            rounded
            :disabled="!valid"
            @click.prevent="saveChanges"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            Сохранить
          </v-btn>
          <v-btn
            text
            class="text-none"
            @click.prevent="returnAccessKeys()"
          >
            Отменить
          </v-btn>
        </div>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { accessKeysListLocation } from '@/components/accessKeys/accessKeysListRoute';

export default {
  name: 'EditAccessKey',
  props: ['id'],
  data () {
    return {
      valid: true,
      codeKey: '',
      nameKey: '',
      comment: '',
      typeKey: [
        {
          id: 0,
          value: 'Неуниверсальный',
        },
        {
          id: 1,
          value: 'Универсальный',
        },
      ],
      internal_reader: [],
      external_reader: [],
      selectedType: 0,
    };
  },
  created () {
    this.getKey(this.id)
      .then(() => {
        this.codeKey = this.key.code;
        this.nameKey = this.key.name;
        this.comment = this.key.comment;
        this.selectedType = this.key.universal;

        this.internal_reader = this.key.doornum.toString().split('');
        this.external_reader = this.key.ext_reader_doornum.toString().split('');
      });
  },
  computed: {
    ...mapGetters({
      key: 'Keys/key',
    }),
    listLocation () {
      return accessKeysListLocation(this.$route.query);
    },
    items () {
      return [
        {
          text: 'Ключи доступа',
          disabled: false,
          to: this.listLocation,
        },
        {
          text: 'Редактировать ключ',
          disabled: true,
          href: '#',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      getKey: 'Keys/getKey',
      updateKey: 'Keys/updateKey',
    }),
    saveChanges () {
      for (const key in this.$refs) {
        this.$refs[key].validate(true);
      }

      this.$nextTick(() => {
        if (this.valid) {
          let internalReaders = this.internal_reader.sort().join('');
          let externalReaders = this.external_reader.sort().join('');
          internalReaders = (internalReaders === '') ? 0 : parseInt(internalReaders);
          externalReaders = (externalReaders === '') ? 0 : parseInt(externalReaders);

          this.updateKey({
            id: this.id,
            code: this.codeKey,
            name: this.nameKey,
            comment: this.comment,
            universal: this.selectedType,
            internalReaders,
            externalReaders,
          })
            .then(() => {
              this.$router.push(this.listLocation);
              this.$flash_success('Изменения сохранены');
            })
            .catch((err) => {
              if (err.message.includes('422')) {
                const response = err.response.data;
                for (const input in response) {
                  response[input].forEach(error => this.$flash_warning(input + ': ' + error));
                }
              } else {
                this.$flash_warning('Не удалось сохранить изменения');
              }
            });
        }
      });
    },
    returnAccessKeys () {
      this.$router.push(this.listLocation);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-access-key-page {
  padding: 24px;
  max-width: 80%;
}

.edit-access-key-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.edit-access-key-page__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.edit-access-key-page__card {
  border-radius: 12px;
  overflow: hidden;
}

.edit-access-key-page__section {
  padding: 20px 24px;
}

.edit-access-key-page__section--data {
  padding-bottom: 16px;
}

.edit-access-key-page__section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.edit-access-key-page__reader-block {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
}

.edit-access-key-page__reader-title {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #37474f;
  margin-bottom: 12px;
}

.edit-access-key-page__reader-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
}

.edit-access-key-page__actions {
  padding: 16px 24px 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

@media screen and (max-width: 600px) {
  .edit-access-key-page__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .edit-access-key-page__title {
    font-size: 1.4rem;
  }
}
</style>
